exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n#xsExportDeliveries .searchDropdownDiv {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n#xsExportDeliveries .searchDropdownLabel {\n  color: #78849e;\n  line-height: 22px;\n  pointer-events: none;\n  font-size: 8pt;\n  padding-left: 10px;\n}\n", ""]);

// exports
